import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/react';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://a1c593901b8bce37af791fa3a68b7127@o4505908202242048.ingest.sentry.io/4505919576080384',
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: ['localhost', /^https:.*.io\/api/],
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if ('serviceWorker' in navigator) {
  // Add a small delay to ensure the app loads first
  setTimeout(() => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registered:', registration);
      })
      .catch((error) => {
        console.warn('⚠️ Service Worker registration failed (this is normal in some browsers):', error);
        // Don't throw error - just log it as this shouldn't block the app
      });
  }, 1000);
}
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Sentry.ErrorBoundary fallback={'An error has occurred'}>
    <App />
  </Sentry.ErrorBoundary>
);

reportWebVitals();
